import { gql } from "@apollo/client";

export const GENERATE_FLEET_EXPENDITURE_REPORT = gql`
  query downloadFleetExpenditureReport($duration: Int!, $vehicleIds: [String]!) {
    downloadFleetExpenditureReport(duration: $duration, vehicleIds: $vehicleIds) {
      key
      message
    }
  }
`;